import React, { useState } from 'react';
import { Colors, Spacing, Typography } from '_styles';
import Form from 'react-bootstrap/Form';
import { FiEdit2 } from 'react-icons/fi';

const HoverIcon = (props) => {
    
    const [hover, setHover] = useState(false);

    return (
        <div style={{display:'flex', marginTop:5, justifyContent:'space-between', color:hover ? Colors.PRM_LIGHT_BLUE : 'grey', cursor:'pointer'}}>
            <Form.Label onClick={props.onClick} onMouseOver={()=>{setHover(true)}} onMouseLeave={()=>{setHover(false)}} style={{ color:Colors.PRM_LIGHT_BLUE}}>{props.label}</Form.Label>
            <FiEdit2 size={18} onMouseOver={()=>{setHover(true)}} onMouseLeave={()=>{setHover(false)}} onClick={props.onClick} />
        </div>
    );
}

export default HoverIcon;